export default __webpack_public_path__ + "static/media/bank.82c2fa3c.png";